interface TemplateRegexError {
  regex: RegExp;
  replaceString?: string;
  replaceFunction?: (substring: string, ...args: any[]) => string;
  replaceLimit?: number;
  [x: string]: any;
}

interface TemplateTagError {
  selector: string;
  classList?: string[];
  attributeList?: Record<string, string>;
  [x: string]: any;
}

interface TemplateError {
  regexList?: TemplateRegexError[];
  tagList?: TemplateTagError[];
  [x: string]: any;
}

/**
 * getErrorMap
 * @param key key
 * @returns
 */
export const getErrorMap = (key: string): TemplateError => {
  switch (key) {
    case 'p-price':
      return {
        regexList: [
          {
            regex: /{{[\s]*?assign[\s]*?dataOldFormat[\s]*?=[\s]*?''[\s]*?}}/g,
            replaceString: "{% assign dataOldFormat = '' %}",
          },
          /* {
            regex: /<div[\s]*?class="gf_product-prices"[\s]*?data-oldformat="{{[\s]*?shop\.money_format[\s]*?}}"[\s]*?data-oldcurrency="{{[\s]*?shop\.currency[\s]*?}}">/g,
            replaceString: "{% assign dataOldFormat = '' %}\n{% if shop.money_format %}\n{% capture dataOldFormat %}{{ shop.money_format | replace: '\"', \"'\" }}{% endcapture %}\n{% endif %}\n<div class=\"gf_product-prices\" data-oldformat=\"{{ dataOldFormat }}\" data-oldcurrency=\"{{ cart.currency.iso_code }}\">",
          },
          {
            regex: /{%[\s]*?endif[\s]*?%}[\s]*?{%[\s]*?if[\s]*?current_variant\.compare_at_price[\s]*?!=[\s]*?null[\s]*?%}/g,
            replaceString: "{% else %}",
          }, */
        ],
      };
    case 'p-description':
      return {
        regexList: [
          /* {
            regex: /{%[\s]*?assign[\s]*?count[\s]*?=[\s]*?0[\s]*?%}/g,
            replaceString: "{% assign gPDCount = 0 %}",
          },  */
          {
            regex:
              /{%[\s]*?if[\s]*?checkSec[\s]*?!=[\s]*?''[\s]*?or[\s]*?\([\s]*?\([\s]*?testDescSec[\s]*?contains[\s]*?'img'[\s]*?or[\s]*?testDescSec[\s]*?contains[\s]*?'video'[\s]*?or[\s]*?testDescSec[\s]*?contains[\s]*?'iframe'[\s]*?\)[\s]*?and[\s]*?testDescSec[\s]*?contains[\s]*?'src'[\s]*?\)[\s]*?%}[\s]*?{%[\s]*?assign[\s]*?count[\s]*?=[\s]*?count[\s]*?\|[\s]*?plus:[\s]*?1[\s]*?%}[\s]*?{%[\s]*?if[\s]*?count[\s]*?==[\s]*?secNum[\s]*?%}/g,
            replaceString:
              "{% assign isMediaSec = false %}\n{% if testDescSec contains 'img' or testDescSec contains 'video' or testDescSec contains 'iframe' %}\n{% if testDescSec contains 'src' %}\n{% assign isMediaSec = true %}\n{% endif %}\n{% endif %}\n{% if checkSec != '' or isMediaSec %}\n{% assign count = count | plus: 1 %}\n{% if count == secNum %}",
          },
          {
            regex:
              /{%[\s]*?if[\s]*?checkSec[\s]*?!=[\s]*?''[\s]*?or[\s]*?\([\s]*?\([\s]*?testDescSec[\s]*?contains[\s]*?'img'[\s]*?or[\s]*?testDescSec[\s]*?contains[\s]*?'video'[\s]*?or[\s]*?testDescSec[\s]*?contains[\s]*?'iframe'[\s]*?\)[\s]*?and[\s]*?testDescSec[\s]*?contains[\s]*?'src'[\s]*?\)[\s]*?%}[\s]*?{%[\s]*?assign[\s]*?gPDCount[\s]*?=[\s]*?gPDCount[\s]*?\|[\s]*?plus:[\s]*?1[\s]*?%}[\s]*?{%[\s]*?if[\s]*?gPDCount[\s]*?==[\s]*?secNum[\s]*?%}/g,
            replaceString:
              "{% assign isMediaSec = false %}\n{% if testDescSec contains 'img' or testDescSec contains 'video' or testDescSec contains 'iframe' %}\n{% if testDescSec contains 'src' %}\n{% assign isMediaSec = true %}\n{% endif %}\n{% endif %}\n{% if checkSec != '' or isMediaSec %}\n{% assign gPDCount = gPDCount | plus: 1 %}\n{% if gPDCount == secNum %}",
          },
          /* {
            regex: /{%[\s]+assign[\s]*?chosenDescSec[\s]*?=[\s]*?chosenDescSec[\s]*?\|[\s]*?strip[\s]*?%}[\s\S]+{%[\s]*?endfor[\s]*?%}[\s]*?{%[\s]*?else[\s]*?%}[\s]*?{{[\s]*?product\.body_html[\s]*?\|[\s]*?strip[\s]*?}}[\s]*?{%[\s]*?endif[\s]*?%}/g,
            replaceString: "<object>{{ chosenDescSec | strip }}</object>",
          }, */
        ],
      };
    case 'p-image':
      return {
        regexList: [
          {
            regex: /{%[\s]*?assign[\s]*?hoverImage[\s]*?=[\s]*?product.images[\s]*?\|[\s]*?{{imgEffectNth}}[\s]*?%}/g,
            replaceString: '{% assign hoverImage = product.images | last %}',
          },
          /*  {
            regex: /data-zoom[s|S]tyle="{{zoomStyle}}"/g,
            replaceString: "data-zoom-level=\"{{zoomLevel}}\""
          },
          {
            regex: /{%[\s]*?assign[\s]*?featured_image[\s]*?=[\s]*?current_variant\.featured_image[\s]*?\|[\s]*?default:[\s]*?product\.featured_image[\s]*?%}[\s]*?{%[\s]*?if[\s]*?featured_image[\s]*?%}/g,
            replaceString: "{% assign featured_image = current_variant.featured_image | default: product.featured_image %}\n{% if '{{badgeMod}}' == '1' %}\n{% assign anchorClass = 'active' %}\n{%else%}\n{% assign anchorClass = 'hide' %}\n{%endif%}\n{%if '{{percentagePrice}}'=='1' %}\n{% assign currentPrice = current_variant.price | plus: 0 %}\n{% assign comparePrice = current_variant.compare_at_price | plus: 0 %}\n{% if currentPrice and currentPrice %}\n{% if currentPrice &#60; comparePrice %}\n{% assign diff = comparePrice | minus: currentPrice %}\n{%else%}\n{% assign diff = currentPrice | minus: comparePrice %}\n{%endif%}\n{% assign comparePriceFloat = comparePrice | times: 1.0 %}\n{% if comparePriceFloat !=0 %}\n{% assign diff = diff | divided_by: comparePriceFloat %}\n{% endif %}\n{% assign diff = diff | times: 100.0 %}\n{% assign saleOffValue = diff |round %}\n{%endif%}\n{%else%}\n{% assign saleOffValue = '' %}\n{%endif%}\n{% if featured_image %}",
          }, */
        ],
        /* tagList: [
          {
            selector: "div.module",
            attributeList: {
              "data-displaytype": "{{displayType}}",
              "data-displayunit": "{{textUnit}}",
              "data-badgemod": "{{badgeMod}}"
            },
          },
          {
            selector: "a[href=\"/products/{{ product.handle }}\"]",
            classList: ["img-hover"]
          },
          {
            selector: "img.gf_product-image",
            attributeList: {
              "natural-width": "{{ featured_image.width }}",
              "natural-height": "{{ featured_image.height }}",
              "width": "{{ featured_image.width }}",
              "height": "{{ featured_image.height }}", "data-width": "{{width}}",
              "data-height": "{{height}}"
            }
          }
        ], */
      };
    case 'stamped':
      return {
        regexList: [
          {
            regex:
              /{{[\s]*?product\.featured_image[\s]*?\|[\s]*?product_img_url:[\s]*?"large"[\s]*?\|replace:[\s]*?'\?'[\s]*?,[\s]*?'%3F'[\s]*?\|[\s]*?replace:[\s]*?'&'[\s]*?,[\s]*?'%26'[\s]*?}}/g,
            replaceString:
              "{{ product.featured_image | product_img_url: 'large' | replace: '?', '%3F' | replace: '&','%26'}}",
          },
        ],
      };
    case 'stamped-product-reviews':
      return {
        regexList: [
          {
            regex:
              /{{[\s]*?product\.featured_image[\s]*?\|[\s]*?product_img_url:[\s]*?"large"[\s]*?\|replace:[\s]*?'\?'[\s]*?,[\s]*?'%3F'[\s]*?\|[\s]*?replace:[\s]*?'&'[\s]*?,[\s]*?'%26'[\s]*?}}/g,
            replaceString:
              "{{ product.featured_image | product_img_url: 'large' | replace: '?', '%3F' | replace: '&','%26'}}",
          },
        ],
      };
    default:
      return {};
  }
};

/**
 * auto fix theme follow key of module
 * @param key key of module
 * @param defaultTemplate old template from _blank.html
 * @returns new
 */
export const autoFixTemplate = (key: string, defaultTemplate: string) => {
  let template = defaultTemplate;
  let isChange = false;

  const map = getErrorMap(key);
  if (map.tagList) {
    const $template = $(document.createElement('div'));
    $template.html(template);
    map.tagList.forEach((item) => {
      const $element = $template.find(item.selector);

      if (item.classList) {
        item.classList.forEach((className) => {
          if (!$element.hasClass(className)) {
            $element.addClass(className);
            isChange = true;
          }
        });
      }

      if (item.attributeList) {
        const attributeList = item.attributeList;
        Object.keys(attributeList).forEach((attribute) => {
          if (!$element.attr(attribute)) {
            $element.attr(attribute, attributeList[attribute] as string);
            isChange = true;
          }
        });
      }
    });
    template = String($template.html());
    template = template.replaceAll(/&lt;/g, '<');
  }

  if (map.regexList) {
    map.regexList.forEach((item) => {
      if (item.regex.test(template)) {
        if (item.replaceString) {
          template = template.replace(item.regex, item.replaceString);
        } else if (item.replaceFunction) {
          template = template.replace(item.regex, item.replaceFunction);
        }
        isChange = true;
      }
    });
  }

  return {
    template,
    isChange,
  };
};

/**
 * checkVersion
 * @param module
 * @returns
 */
export const checkVersion = (module: any) => {
  const key = module.getModuleKey();
  if (['p-price', 'p-description', 'p-image', 'stamped', 'stamped-product-reviews'].includes(key)) {
    const version = module.getModuleVersion();

    // if module version equal or higher available version => does't need to change
    if (key == 'p-price' && version >= import.meta.env.VITE_APP_P_PRICE_VERSION) {
      return false;
    }

    if (key == 'p-description' && version >= import.meta.env.VITE_APP_P_DESCRIPTION_VERSION) {
      return false;
    }

    if (key == 'p-image' && version >= import.meta.env.VITE_APP_P_IMAGE_VERSION) {
      return false;
    }

    // else check have modules been fixed
    return module.getModuleFixVersion() < import.meta.env.VITE_APP_FIX_VERSION;
  }
  return false;
};

/**
 * check Auto Template
 * @param module
 */
export const autoCheckTemplate = (module: any) => {
  const win = window as any;

  if (win.__gpAutoFixTemplate) {
    if (checkVersion(module)) {
      const { template, isChange } = autoFixTemplate(
        module.getModuleKey() as string,
        module.getModuleTemplate() as string,
      );
      if (isChange) {
        module.setModuleTemplate(template, true);
        module.setModuleFixVersion(import.meta.env.VITE_APP_FIX_VERSION);
      }
    }

    /**
     * During editor initializes collection list
     * Reassign Auto fix theme whenever a child of collection list initializes
     * After the last child finished initializes, clear auto fix theme flag
     */
    if (win.__gpAutoFixTemplate?.label == 'collection') {
      // when auto fix theme for "collection" module
      clearTimeout(win.__gpAutoFixTemplate.timeout); // reassign auto fix template timout

      // 5s later and no module is initialized, the editor has completed initialization
      win.__gpAutoFixTemplate.timeout = setTimeout(() => {
        clearTimeout(win.__gpAutoFixTemplate.timeout);
        win.__gpAutoFixTemplate = null;
      }, 5000);
    }
  }
};
